import Offer from './Offer';

export default Offer;
